export const environment = {
  production: false,
  backend: 'https://api.dev.mobilitycompany.it',
  idamSso: 'https://idam.dev.mobilitycompany.it/auth/welcome',
  urlSsoLogout: 'https://idam.dev.mobilitycompany.it/auth/logout',
  account: 'https://account.dev.mobilitycompany.it',
  portal: 'https://home.dev.mobilitycompany.it',
  ambient: 'dev',
};
